import NoDataRow from "../../../../../components/reports/no-data-row.jsx";
import RegisteredOccurrenceVehiclesService from "../../../../../services/reports/registered-occurrence-vehicles-service.js";
import ProjectUtils from "../../../../../utils/project-utils.js";
import PlatePatternUtils from "../../../../../utils/plate-pattern-utils.js";
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";

function TSpan({ children, className = "" }) {
    return (
        <span className={`mr-2 text-zinc-600 font-bold ${className}`}>
            {children}
        </span>
    )
}

export default function ReportContent({ data }) {
    const vehicle = data?.data?.vehicle;
    const occurrences = data?.data?.occurrences;

    return (
        <>
            <div className="report-divisor">
                <span className="divisor-title">SITUAÇÃO CADASTRAL DO VEÍCULO</span>
            </div>
            <table
                id="registration-vehicles-status-data"
                className="table report-table !border-b-0"
                sheet-name="Veículo cadastado em ocorrência"
            >
                <tbody className="bg-white !border-b-0">
                <tr className="table-break-word !border-b-0">
                    <td className="py-5! px-2! !border-b-0">
                        <div className="flex justify-start gap-10">
                            <div className="space-y-4 w-[29%]">
                                <div>
                                    <TSpan>Placa:</TSpan>
                                    <span>{vehicle?.plate ? platePatternUtils.formatPlate(vehicle.plate) : "Não informado"}</span>
                                </div>
                                <div>
                                    <TSpan>Marca / Modelo:</TSpan>
                                    <span>{vehicle?.brandmodel ?? "Não informado"}</span>
                                </div>
                                <div>
                                    <TSpan>Cor:</TSpan>
                                    <span>{vehicle?.color ?? "Não informado"}</span>
                                </div>
                            </div>

                            <div className="space-y-4  w-[71%]">
                                <div>
                                    <TSpan>Tipo:</TSpan>
                                    <span>{vehicle?.type ?? "Não informado"}</span>
                                </div>
                                <div>
                                    <TSpan>Ano do modelo:</TSpan>
                                    <span>{vehicle?.modelyear ?? "Não informado"}</span>
                                </div>
                                <div>
                                    <TSpan>Município da placa:</TSpan>
                                    <span>{vehicle?.city ?? "Não informado"}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>

                <span className="obs-warn text-right">* Informações extraídas do cadastro de veículos do Sentry</span>

                </tbody>
            </table>
            <div className="chart-divisor" />
            <div className="mt-4">
                <span className="chart-title mb-4">Veículo cadastrado nas seguintes ocorrências:</span>
                <table
                    id="registered-occurrence-vehicles-data"
                    className="table report-table mt-4"
                    sheet-name="Veículo cadastado em ocorrência"
                >
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            <th className="w-[30%]">ID da ocorrência</th>
                            <th className="w-[30%]">Natureza(s)</th>
                            <th className="w-[20%]">Classificação</th>
                            <th className="w-[20%]">Visibilidade</th>
                        </tr>
                    </thead>
                    <tbody>
                    {occurrences.length === 0 ? (
                        <NoDataRow
                            colSpan={4}
                            message={"Não há ocorrências associadas a este veículo"}
                        />
                    ) : (
                        occurrences.map((element, index) => (
                            <tr key={element.id ?? index}>
                                <td>
                                    <button
                                        type="button"
                                        onClick={() => RegisteredOccurrenceVehiclesService.openSentryView(element.id)}
                                        className="text-[#1588F3]  underline cursor-pointer print:text-black print:!no-underline"
                                    >
                                        {element.id ?? ""}
                                    </button>
                                </td>
                                <td>{element.reason?.join(", ") ?? ""}</td>
                                <td>{element.classification ?? ""}</td>
                                <td>{element.visibility ?? ""}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
            <div id="chart-tables" />
        </>
    )
}